(() => {
  if (window.krListingHoverInstalled) return;
  window.krListingHoverInstalled = true;
  const states = new WeakMap();
  const pointer = matchMedia('(hover:hover) and (pointer:fine)');
  function enter(card) {
    let state = states.get(card);
    if (!state) {
      const image = card.querySelector('.product-card__image .media:not(.product-card__image--hover) img, .kr-product-card__image, .kr-related-card__mount img, .kr-fc-1ac__image, .kr-fc-2b__image, .kr-fc-2d__image') || card.querySelector('img:not(.kr-listing-secondary)');
      if (!image || !card.dataset.krHoverSrc) return;
      const parent = image.parentElement;
      if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
      const second = image.cloneNode(false);
      second.removeAttribute('srcset'); second.removeAttribute('sizes'); second.removeAttribute('id');
      second.removeAttribute('data-colour-image'); second.removeAttribute('data-image-position');
      second.className = 'kr-listing-secondary'; second.alt = ''; second.setAttribute('aria-hidden','true');
      second.loading = 'eager';
      image.classList.add('kr-listing-primary');
      state = {image, second, active:false, ready:false}; states.set(card,state);
      second.addEventListener('load', () => { state.ready = second.naturalWidth > 0; reveal(state); });
      second.addEventListener('error', () => { state.ready = false; reveal(state); });
      parent.append(second); second.src = card.dataset.krHoverSrc;
    }
    state.active = true;
    const style = getComputedStyle(state.image);
    Object.assign(state.second.style, {left:state.image.offsetLeft+'px',top:state.image.offsetTop+'px',width:state.image.offsetWidth+'px',height:state.image.offsetHeight+'px',objectFit:style.objectFit,objectPosition:style.objectPosition,borderRadius:style.borderRadius,transform:style.transform});
    reveal(state);
  }
  function reveal(s) {
    const show = s.active && s.ready;
    s.image.classList.toggle('kr-listing-revealed',show);
    s.second.classList.toggle('kr-listing-revealed',show);
  }
  function leave(card) { const s=states.get(card); if(s){s.active=false;reveal(s);} }
  document.addEventListener('pointerover', e => {
    if (!pointer.matches) return;
    const card=e.target.closest('[data-kr-hover="on"]');
    if(card&&!card.contains(e.relatedTarget)) enter(card);
  });
  document.addEventListener('pointerout', e => {
    const card=e.target.closest('[data-kr-hover="on"]');
    if(card&&!card.contains(e.relatedTarget)) leave(card);
  });
  document.addEventListener('focusin', e => { const card=e.target.closest('[data-kr-hover="on"]');if(card)enter(card); });
  document.addEventListener('focusout', e => { const card=e.target.closest('[data-kr-hover="on"]');if(card&&!card.contains(e.relatedTarget))leave(card); });
})();
